import { Box, Skeleton } from '@mui/material';

//=================================================================================================
export default function KosaSkeleton() {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', px: 1.5, py: 0.5, gap: 1 }}>
            <Skeleton variant="circular" width={14} height={14} sx={{ flexShrink: 0 }} />
            <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                <Skeleton variant="text" sx={{ fontSize: 'body2.fontSize' }} width="60%" />
                <Skeleton variant="text" sx={{ fontSize: 'caption.fontSize' }} width="40%" />
            </Box>
        </Box>
    );
}
